var map = {
	"./EYEBROWS1.svg": 53667,
	"./EYEBROWS10.svg": 55135,
	"./EYEBROWS11.svg": 39934,
	"./EYEBROWS2.svg": 25016,
	"./EYEBROWS3.svg": 41926,
	"./EYEBROWS4.svg": 67904,
	"./EYEBROWS5.svg": 96068,
	"./EYEBROWS6.svg": 95059,
	"./EYEBROWS7.svg": 32338,
	"./EYEBROWS8.svg": 91702,
	"./EYEBROWS9.svg": 8457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 964;